<section class="wb-popup-small" id="popup-small-delete" style="display: block;">

  <div class="grid-x align-center word-wrap">
    <div class="cell shrink align-self-middle">
      <div class="content">

        <ul>
          <li>
            <h3>{{data.title}}</h3>
            <p>{{data.Message}}</p>
          </li>
          <li>
            <button *ngIf="data.showCancelButton" class="button grey" (click)="cancelClick()">Cancel</button>
            <button class="button" mat-button mat-dialog-close="true">Ok</button>
          </li>
        </ul>

      </div>
    </div>
  </div>

</section>